import axios from '@/utils/axios'

export const getBankAccount = (payload) => {
    return axios.get('/receive_account', {
        params: payload
    })
}

export const getSimpleBankAccount = (payload) => {
    return axios.get('/simple_receive_account', {
        params: payload
    })
}

export const createAccount = (data) => {
    return axios.post('/receive_account', data)
}

export const updateBankAccount = (id, data) => {
    return axios.put(`/receive_account/${id}`, data)
}

export const deletePurchase = (id) => {
    return axios.delete(`/calcPurchase/${id}`)
}